import { authorizedBillingFetch } from 'app/axios/billing'

export function fetchBillingHistory(rootDomainId: string, lastObjId: string) {
  if (lastObjId !== '') {
    return authorizedBillingFetch.get(
      `/root-domain/${rootDomainId}/charges?limit=10&lastObjId=${lastObjId}`
    )
  } else {
    return authorizedBillingFetch.get(
      `/root-domain/${rootDomainId}/charges?limit=10`
    )
  }
}
